import _ from 'lodash';
import { DATE_FORMATS } from './static';
import { leftPad } from './TZDate';

export function formatTZDate(dateObj, formatType, fallbackType) {
  const isValidFormat = _.values(DATE_FORMATS).some(
    format => format === formatType
  );
  const year = dateObj.getFullYear();
  const month = leftPad(dateObj.getMonth() + 1, 2);
  const day = leftPad(dateObj.getDate(), 2);
  const hours = leftPad(dateObj.getHours(), 2); // 24h
  const minutes = leftPad(dateObj.getMinutes(), 2); // minutes
  const normalizedFormat = isValidFormat ? formatType : fallbackType;

  switch (normalizedFormat) {
    // time formats
    case DATE_FORMATS.TIME_FORMAT_1:
      return formatTime(`${hours}:${minutes}`, normalizedFormat);
    case DATE_FORMATS.TIME_FORMAT_2:
      return formatTime(`${hours}:${minutes}`, normalizedFormat);

    // date formats
    case DATE_FORMATS.DATE_FORMAT_1:
      return `${year}-${month}-${day}`;
    case DATE_FORMATS.DATE_FORMAT_2:
      return `${year}/${month}/${day}`;
    case DATE_FORMATS.DATE_FORMAT_3:
      return `${month}-${day}-${year}`;
    case DATE_FORMATS.DATE_FORMAT_4:
      return `${day}.${month}.${year}`;
    case DATE_FORMATS.DATE_FORMAT_5:
      return `${day}-${month}-${year}`;
    case DATE_FORMATS.DATE_FORMAT_6:
      return `${day}/${month}/${year}`;
    default:
      return `${year}-${month}-${day}`;
  }
}

export function formatTime(timeStr, formatType) {
  if (formatType === DATE_FORMATS.TIME_FORMAT_2) {
    return timeStr;
  }

  if (timeStr === '24:00') {
    return 'midnight';
  }

  const [hourStr, minuteStr] = timeStr.split(':');
  let hour = parseInt(hourStr, 10);

  const postFix = hour < 12 ? 'am' : 'pm';
  const hourFormated = `${hour % 12 || 12}`;
  const minuteFormated = minuteStr === '00' ? '' : `:${minuteStr}`;

  return `${hourFormated}${minuteFormated}${postFix}`;
}



// WEBPACK FOOTER //
// ./src/commons/services/dateHelpers.js